import store from '@/store'

export default [
  {
    path: '/transportation-distances',
    name: 'transportation-distance',
    meta: { requiresAuth: true },
    component: () => import('@/pages/transportation-distance/form.vue'),
    beforeEnter: async (to, from, next) => {
      next()
    }
  },
  {
    path: '/transportation-distances/:id',
    name: 'transportation-distance-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/transportation-distance/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('transportationDistance/find', to.params.id)
      next()
    }
  }
]
